<template>
    <div>
    <nav class="navbar navbar-expand-lg navbar-dark text-uppercase ff-n27-bold bg-navbar">
    <div class="container-fluid px-xl-5 px-lg-3 py-3 py-lg-4">
      <a class="navbar-brand" :href="getUrl('homeUrl')"><img class="nav-logo" src="~__STATIC__/icon_svg/valle_white.svg" alt="logo"></a>
      <a class="navbar-brand" :href="getUrl('homeUrl')"><img class="nav-logo" src="~__STATIC__/svg/valle-plus.svg" alt="logo"></a>
      <a class="btn btn-primary order-lg-5 text-white position-relative py-2" href="#" @click="toggle" v-if="showCart">
        <img class="cart-icon d-lg-none" src="~__STATIC__/svg/cart.svg" alt="logo">
        <span class="header--cart--counter">{{ count }}</span>
<!--        <img class="nav-logo-cart" src="~__STATIC__/img/cart.png" alt="logo">-->
        <span class="d-none d-lg-inline ml-2">Carrito de compras</span>
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarMain"
              aria-controls="navbarMain" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse mt-3 pt-3 mt-lg-0 pt-lg-0" id="navbarMain">
        <ul class="navbar-nav ml-auto flex-lg-row-reverse">
          <li class="nav-item px-xl-3 text-lg-center align-self-lg-center">
            <a class="nav-link text-white" :class="{ emarcacion: isActive('userDashboardUrl') }" aria-current="page" :href="getUrl('userDashboardUrl')">
              <img class="mr-1 d-none d-lg-inline" src="~__STATIC__/icon_svg/ski_rental.svg" alt="Login">
              Ingresa
              <img class="ml-2 d-lg-none" src="~__STATIC__/icon_svg/ski_rental.svg" alt="Login">
            </a>
          </li>
          <li class="nav-item px-xl-3 text-lg-center align-self-lg-center">
            <a class="nav-link text-white" :class="{ emarcacion: isActive('vbUrl') }" :href="getUrl('vbUrl')">
              <img class="mr-1 d-none d-lg-inline" src="~__STATIC__/icon_svg/promo.svg" alt="Recarga">
              Recarga cuponera
              <img class="ml-2 d-lg-none" src="~__STATIC__/icon_svg/promo.svg" alt="Recarga">
            </a>
          </li>
          <li class="nav-item px-xl-3 text-lg-center align-self-lg-center">
            <a class="nav-link text-white" :class="{ emarcacion: isActive('cardDataUrl') }" :href="getUrl('cardDataUrl')" v-text="getTranslation('cardDataLabel')">jaja</a>
          </li>
          <li class="nav-item px-xl-3 text-lg-center align-self-lg-center">
            <a class="nav-link text-white" :class="{ emarcacion: isActive('faqUrl') }" :href="getUrl('faqUrl')" v-text="getTranslation('faqLabel')"></a>
          </li>
<!--          <li class="nav-item px-xl-3 text-lg-center align-self-lg-center">
            <a class="nav-link text-white" :href="getUrl('healthUrl')" v-text="getTranslation('healthLabel')"></a>
          </li>-->
        </ul>
      </div>
    </div>
  </nav>
</div>

</template>

<script>
    import * as Actions from '../store/action-types';
    import cartMixin from '../mixins/cartMixin';
    import siteConfig from '../mixins/siteConfig';

    export default {
        props: {
            showCart: {
                type: Boolean,
                default() {
                    return true;
                }
            },
            promo: {
                type: Boolean,
                default() {
                    return true;
                }
            }
        },

        mixins: [cartMixin, siteConfig],

        computed: {
            user() {
                return window.Valle.user && window.Valle.user.name
                    ? window.Valle.user.name.split(' ')[0]
                    : undefined;
            },

            welcomeMessage() {
                return `${this.getTranslation('helloLabel')}, ${this.user}`;
            },
            currentPath() {
            return window.location.pathname;
        }
        },

        methods: {
            toggle() {
                this.$store.dispatch(Actions.toggleFooter);
            },
            isActive(routeName) {
            // Define aquí las rutas de cada opción
            const routes = {
                userDashboardUrl: '/store/customer/home/',
                vbUrl: '/store/order/detail/search/',
                cardDataUrl: '/consultar-productos',
                faqUrl: '/faq'
            };
            return this.currentPath === routes[routeName];
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue